import { render, staticRenderFns } from "./LookMenu.vue?vue&type=template&id=20e179ad&"
import script from "./LookMenu.vue?vue&type=script&lang=js&"
export * from "./LookMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports